import type { Incident, IncidentSeverity } from "./types";

const SEVERITY_LABELS: Record<IncidentSeverity, string> = {
  none: "",
  info: "Информация",
  warning: "Предупреждение",
  critical: "Критический инцидент",
  resolved: "Восстановлено",
};

export function renderIncidentFeed(
  container: HTMLElement,
  incidents: Incident[],
): void {
  const lead = incidents[0];

  // Show the chain only when the freshest incident is active; older entries
  // below it are kept as recent history.
  if (!lead || !lead.active) {
    container.hidden = true;
    container.replaceChildren();
    container.className = "incident-timeline";
    return;
  }

  container.hidden = false;
  container.className = "incident-timeline";

  const entries = incidents.map((incident, index) =>
    renderTimelineEntry(incident, index === 0),
  );
  container.replaceChildren(...entries);
}

function renderTimelineEntry(incident: Incident, isLead: boolean): HTMLElement {
  const severity = incident.severity === "none" ? "info" : incident.severity;

  const entry = document.createElement("div");
  entry.className = [
    "timeline-entry",
    `timeline-entry--${severity}`,
    isLead ? "timeline-entry--lead" : "",
  ]
    .filter(Boolean)
    .join(" ");

  // Left: date / time
  const timeCol = document.createElement("div");
  timeCol.className = "timeline-entry__time";
  if (incident.updatedAt) {
    const dateLine = document.createElement("span");
    dateLine.className = "timeline-entry__date-text";
    dateLine.textContent = formatDate(incident.updatedAt);

    const timeLine = document.createElement("span");
    timeLine.className = "timeline-entry__time-text";
    timeLine.textContent = formatTime(incident.updatedAt);

    timeCol.append(dateLine, timeLine);
  }

  // Center: spine
  const spine = document.createElement("div");
  spine.className = "timeline-entry__spine";

  const dot = document.createElement("div");
  dot.className = "timeline-entry__dot";

  const line = document.createElement("div");
  line.className = "timeline-entry__line";

  spine.append(dot, line);

  // Right: content
  const body = document.createElement("div");
  body.className = "timeline-entry__body";

  const label = document.createElement("span");
  label.className = "timeline-entry__label";
  label.textContent = SEVERITY_LABELS[severity];

  const title = document.createElement("h2");
  title.className = "timeline-entry__title";
  title.textContent = incident.title || "Активный инцидент";

  body.append(label, title);

  if (incident.message) {
    const message = document.createElement("p");
    message.className = "timeline-entry__message";
    message.textContent = incident.message;
    body.append(message);
  }

  entry.append(timeCol, spine, body);

  return entry;
}

function formatDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat("ru-RU", {
    day: "numeric",
    month: "short",
  }).format(date);
}

function formatTime(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("ru-RU", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}
